// extracted by mini-css-extract-plugin
module.exports = {"w100":"faqLayout-module--w100--1fg4p"};